import { styled } from 'styled-components';

import { Image } from 'src/components/image';
import { breakpointTablet } from 'src/styles/breakpoints';
import { spacing1 } from 'src/styles/spacing';

export const StyledImage = styled(Image)`
  max-height: 77px;
  max-width: 100%;
  min-width: 0;

  @media (min-width: ${breakpointTablet}) {
    margin-right: ${spacing1};
  }
`;

export const StyledDefaultImage = styled(Image)`
  max-width: 80px;

  @media (min-width: ${breakpointTablet}) {
    max-width: 120px;
  }
`;
